import dayjs from "dayjs";
import { useEffect } from "react";

type useNormalizeDateRangeProps = {
  checkin: string;
  checkout: string;
  setRange: (from?: Date, to?: Date) => void;
  enabled?: boolean;
};

/**
 * Normalize date range
 * @param checkin - Checkin date
 * @param checkout - Checkout date
 * @param setRange - Set range
 */
export const useNormalizeDateRange = ({
  checkin,
  checkout,
  setRange,
  enabled = true,
}: useNormalizeDateRangeProps) => {
  useEffect(() => {
    if (!enabled) return;

    const currentToday = dayjs().startOf("day");
    const parsedCheckin =
      checkin && dayjs(checkin).isValid() ? dayjs(checkin) : null;
    const parsedCheckout =
      checkout && dayjs(checkout).isValid() ? dayjs(checkout) : null;

    const normalizedCheckin =
      !parsedCheckin || parsedCheckin.isBefore(currentToday, "day")
        ? currentToday
        : parsedCheckin;

    let normalizedCheckout = parsedCheckout;
    if (
      !normalizedCheckout ||
      !normalizedCheckout.isAfter(normalizedCheckin, "day")
    ) {
      normalizedCheckout = normalizedCheckin.add(1, "day");
    }

    const nextCheckin = normalizedCheckin.format("YYYY-MM-DD");
    const nextCheckout = normalizedCheckout.format("YYYY-MM-DD");

    if (nextCheckin === (checkin ?? "") && nextCheckout === (checkout ?? ""))
      return;

    void setRange(normalizedCheckin.toDate(), normalizedCheckout.toDate());
  }, [checkin, checkout, enabled, setRange]);
};
